export var vendorMaps = {
    asurion: "Asurion",
    att: "AT&T",
    cricket: "Cricket",
    sprint: "Sprint",
    staples: "Staples",
    verizon: "Verizon",
    agnostic: "",
};
export var expertMaps = {
    asurion: "Expert",
    att: "ProTech",
    cricket: "Expert",
    sprint: "Tech Expert",
    staples: "Expert",
    verizon: "Tech Coach",
    agnostic: "Expert",
};
